import axios from "../axios";

const getAdditionalExpertises = () => {
    return axios.get('/ref/additional-expertise/list')
        .then(response => response.data)
}

export default {
    getAdditionalExpertises
}
